import styled from 'styled-components';
import { compose, margin, width } from 'styled-system';
import { theme } from '../../essentials/theme';
const InputWrapper = styled.div.attrs({ theme }).withConfig({ displayName: "InputWrapper", componentId: "sc-1mbi1g9" }) `
    display: inline-block;
    position: relative;
    box-sizing: border-box;

    ${compose(margin, width)}
`;
export { InputWrapper };
